module.exports = __webpack_public_path__ + "f1f793a8bf35c32985614fc8631d31eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/climbs/climb_1.png
// module id = 1795
// module chunks = 1